function getResizedImageURl(imageId, width, height) {
    var url =  `https://res.cloudinary.com/dxgcobmaz/image/upload/w_${width},h_${height},c_fill,g_face,q_auto:best/${imageId}`;
    return url;
}

export default getResizedImageURl;